import _ from 'lodash';
import {
  Firebase,
  scopeErrorReportingToUser,
  scopeFullstoryCaptureToUser,
  getCurrentTimestamp,
  accountId,
  organizationId,
  isProduction,
  omitDeleted,
  addKeysAsIds,
  unwrapDoc,
  unwrapDocs,
  actionPlanSetupForSprint,
  firstWeeklyReviewConductedForSprint
} from './../util';
import { OrganizationsRef, OrganizationRef, UsersRef, PublicUsersRef, TeamsRef, CurrentSprintsRef, TalentEvaluationsRef } from './../util/refs';

import {
  SYNC_USER,
  //FETCH_EMPLOYEE_DATA,
  LOGOUT,
  //TODO move these elsewhere
  SYNC_USERS,
  SYNC_ORGANIZATION,
  SYNC_EMPLOYEES,
  SYNC_TEAMS,
  FETCH_TEAMS,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_ERROR,

  //For superadmins
  SYNC_ORGANIZATIONS,

} from './types';

// export function fetchEmployeeData(employeeId){
//   return dispatch => {
//     UsersRef().doc(employeeId).onSnapshot(doc => {
//       dispatch({
//         type: FETCH_EMPLOYEE_DATA,
//         payload: doc.data(),
//       });
//     });
//   }
// }

export function syncTeams(){

  return dispatch => {

    //get all teams in organization
    TeamsRef().onSnapshot(docs => {

      const teams = unwrapDocs(docs);

      dispatch({
        type: SYNC_TEAMS,
        payload: teams,
      });
    });
  }
}

function fetchTeamUsers(memberIds){
  const getUser = memberId => {
    return UsersRef().doc(memberId).get();
  }

  const userFetches = _.map(memberIds, memberId => {
    return getUser(memberId);
  });

  return Promise.all(userFetches);
}

function fetchTeamMembersCurrentSprints(memberIds){
  const getCurrentSprint = memberId => {
    return CurrentSprintsRef().doc(memberId).get();
  }

  const currentSprintFetches = _.map(memberIds, memberId => {
    return getCurrentSprint(memberId);
  });

  return Promise.all(currentSprintFetches);
}

function fetchTeamMembersTalentEvaluations(memberIds){
  const getTalentEvaluations = memberId => {
    return TalentEvaluationsRef().where("userId", "==", memberId).get().then(docs => {
      return unwrapDocs(docs);
    });
  }

  const talentEvaluations = _.map(memberIds, memberId => {
    return getTalentEvaluations(memberId);
  });

  return Promise.all(talentEvaluations);
}

async function fetchTeamData(team){

  const teamUsers = await fetchTeamUsers(team.members);
  const mappedTeamUsers = unwrapDocs(teamUsers);

  //console.log('mappedTeamUsers: ', mappedFirstTeamUsers);

  const teamSprints = await fetchTeamMembersCurrentSprints(team.members);
  const mappedTeamSprints = unwrapDocs(teamSprints);

  //console.log('mappedTeamSprints: ', mappedFirstTeamSprints);

  const teamTalentEvaluations = await fetchTeamMembersTalentEvaluations(team.members);
  const mappedTeamTalentEvaluations = _.union(...teamTalentEvaluations);

  //console.log('mappedTeamTalentEvaluations: ', mappedTeamTalentEvaluations);

  const teamData = {
    ...team,
    memberData: {}
  };

  _.each(mappedTeamUsers, user => {

    const userId = user._id;

    let mappedUser = { ...user };

    //also add full name here for easy accessing
    mappedUser.name = mappedUser.firstName + ' ' + mappedUser.lastName;

    mappedUser.currentSprint = _.find(mappedTeamSprints, { _id: userId });
    mappedUser.talentEvaluations = _.filter(mappedTeamTalentEvaluations, { userId });

    mappedUser.managerSetup = {
      talentEvaluationComplete: _.find(mappedUser.talentEvaluations, talentEvaluation => {
        return talentEvaluation.ratedBy === 'manager';
      }) ? true : false,
      sprintSetup: mappedUser.currentSprint !== undefined,
      actionPlanDefined: actionPlanSetupForSprint(mappedUser.currentSprint),
      /*firstWeeklyReviewConductedForSprint: firstWeeklyReviewConductedForSprint(mappedUser.currentSprint)*/
    };

    mappedUser.managerSetupComplete =   mappedUser.managerSetup.talentEvaluationComplete &&
                                        mappedUser.managerSetup.sprintSetup &&
                                        mappedUser.managerSetup.actionPlanDefined;

    mappedUser.firstWeeklyReviewConductedForSprint = firstWeeklyReviewConductedForSprint(mappedUser.currentSprint);

    teamData.memberData[userId] = mappedUser;
  });

  return teamData;
}

export function fetchMyTeams(managerId = accountId()){

  return async dispatch => {

    dispatch({ type: FETCH_TEAMS });

    try{

      const teams = await TeamsRef().where("leaders", "array-contains", managerId).get();

      const mappedTeams = unwrapDocs(teams);

      // console.log('found teams: ', mappedTeams);

      // if(!mappedTeams || mappedTeams.length === 0){
      //   console.log('NO TEAMS!? HOW DID THIS HAPPEN!?');
      // }

      let fetchAndMapTeamFunctions = _.map(mappedTeams, team => {
        return fetchTeamData(team);
      });

      const mappedTeamData = await Promise.all(fetchAndMapTeamFunctions);

      return dispatch({
        type: FETCH_TEAMS_SUCCESS,
        payload: mappedTeamData,
      });
    }
    catch(err){
      console.log('err fetching my teams: ', err);
      return dispatch({
        type: FETCH_TEAMS_ERROR,
        payload: err.message,
      });
    }
  }
}

export function syncEmployees(){

  return dispatch => {

    //get all users in organization
    UsersRef().where("organizationId", "==", organizationId()).onSnapshot(docs => {
      dispatch({
        type: SYNC_EMPLOYEES,
        payload: unwrapDocs(docs),
      });
    });
  }
}

export function syncOrganization(){
  return dispatch => {
    OrganizationRef().onSnapshot(doc => {
      // console.log('GOT ORGANIZATION!!!');
      // console.log(unwrapDoc(doc));
      dispatch({
        type: SYNC_ORGANIZATION,
        payload: unwrapDoc(doc)
      });
    });
  }
}

export function syncOrganizationsForSuperAdmin(){
  return dispatch => {
    OrganizationsRef().onSnapshot(docs => {
      dispatch({
        type: SYNC_ORGANIZATIONS,
        payload: unwrapDocs(docs)
      });
    });
  }
}

export function changeViewingOrganization(viewingOrganization){
  console.log('should update viewing organization to be: ', viewingOrganization);

  return dispatch => {
    Firebase.firestore().collection('superadmins').doc(accountId()).update({
      viewingOrganization
    }).then(() => {
      dispatch(syncEmployees());
      dispatch(syncTeams());
      dispatch(syncOrganization());
    });
  }
}

function tryFetchingSuperadminData(uid, dispatch){
  Firebase.firestore().collection(`superadmins`).doc(uid).onSnapshot(doc => {
    if(!doc || !doc.data()){
      console.log('Not superadmin either!');
      console.log('cant find user!');
      return;
    }

    //load superadmin data
    scopeErrorReportingToUser(unwrapDoc(doc));
    scopeFullstoryCaptureToUser(unwrapDoc(doc));

    dispatch({
      type: SYNC_USER,
      payload: {
        ...unwrapDoc(doc),
        uid: doc.id
      }
    });

    dispatch(syncOrganizationsForSuperAdmin());
    dispatch(syncEmployees());
    dispatch(syncTeams());
    dispatch(syncOrganization());
  });
}

export function syncUser(){

  console.log('subscribing to user auth state');

  return dispatch => {

    console.log('dispatching...');

    Firebase.auth().onAuthStateChanged(auth => {

      console.log('Firebase Auth state changed to ', auth);

      //console.log('auth state changed - subscribing to changes & reloading EVERYTHING');
      if(!auth){
        dispatch({
          type: SYNC_USER,
          payload: false
        });
      }
      else{

        //console.log('new auth email: ', auth.email);
        const {uid, email, emailVerified, displayName, photoUrl} = auth;

        PublicUsersRef().doc(uid).get().then(doc => {

          //could not find user
          if(!doc || !doc.data()){
            console.log('Could not find user data for account!');

            return tryFetchingSuperadminData(uid, dispatch);
          }

          const organizationId = doc.data().organization;

          //get user data
          Firebase.firestore().collection(`organizations/${organizationId}/users`).doc(uid).onSnapshot(doc => {

            //need access to role to determine what needs to be synced on load
            const { role } = doc.data();

            scopeErrorReportingToUser(unwrapDoc(doc));
            scopeFullstoryCaptureToUser(unwrapDoc(doc));

            dispatch({
              type: SYNC_USER,
              payload: {
                ...unwrapDoc(doc),
                uid: doc.id
              }
            });

            //if admin or manager, get all employee data
            //eventually will limit this to specific pages
            //and/or employees that are part of a manager's team
            if(role === 'admin' || role === 'salesleader'){
              dispatch(syncEmployees());
              dispatch(syncTeams());
            }

            if(role === 'manager'){
              //TODO figure out if all employees are needed
              dispatch(syncEmployees());
              //TODO figure out if this is needed - for now I think we need it
              //for team links to work correctly
              dispatch(syncTeams());

              dispatch(fetchMyTeams(uid));
            }

            //all
            dispatch(syncOrganization());
          });

        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js